import { bl_applet_to_catalog_link_import_file_helper_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';


export class AppletToCatalogLinkFileHelperContainerModel extends BaseContainerModel {
  bl_applet_to_catalog_link_import_file_helper: bl_applet_to_catalog_link_import_file_helper_RowClass = new bl_applet_to_catalog_link_import_file_helper_RowClass();
}
